import React from 'react';
import { Button, Box, Typography, Paper, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CollectorImg from '../images/collector-img.jpg'; 
import TopBarStatic from './TopBarStatic';
import backgroundAnimationData from '../images/logo.png';

const UserTakrar = () => {
    const navigate = useNavigate();

    const handleNavigate = () => navigate('/takrar-pranali-form');
    const handleNavigateStatus = () => navigate('/takrar-status');

    const officials = [
        { name: 'श्री. जितेंद्र पापळकर', title: 'विभागीय आयुक्त, छत्रपती संभाजीनगर', img: CollectorImg },
        // { name: 'श्री. संजय शिरसाट', title: 'मा. मंत्री, सामाजिक न्याय, महाराष्ट्र राज्य तथा पालकमंत्री छत्रपती संभाजीनग', img: SanjayPandurangShirsatImg },
    ];

    return (
        <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
            <TopBarStatic />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: { xs: '90vh', sm: '100vh', md: '140vh', lg: '120vh', xl: "80vh" },
                    background: '#fff',
                    padding: { xs: 2.5, md: 4 },
                }}
            >
                <img
                    src={backgroundAnimationData}
                    alt="Logo"
                    style={{
                        width: window.innerWidth <= 600 ? 40 : 100,
                        marginBottom: 16,
                        marginTop:8
                    }}
                />

                {/* Header Section */}
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '1200px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        mb: 4,
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#000',
                            mb: 2,
                            fontSize: { xs: '24px', sm: '30px', md: '36px', lg: '44px' },
                        }}
                        className="ff_yatra"
                    >
                        सूचना व तक्रार प्रणाली  विभागीय आयुक्त कार्यालय, छत्रपती संभाजीनगर

                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#444',
                            maxWidth: '500px',
                            fontSize: { xs: '14px', sm: '16px', md: '22px' },
                        }}
                        className="ff_baloo"
                    >
                        सूचना व तक्रार प्रणाली  विभागीय आयुक्त कार्यालय, छत्रपती संभाजीनगर
 अंतर्गत नागरिकाची काही तक्रार असेल तर येथून नोंदणी करा
                    </Typography>
                </Box>

                {/* Collector Cards - Side by Side in Mobile */}
                {/* Collector Cards - Desktop Right, Mobile Center */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' }, // Center on mobile, right align on desktop
                        flexWrap: 'wrap',
                        gap: 2,
                        maxWidth: '100%',
                        width: '100%',
                        position: { md: 'absolute' }, // Position it to the right on larger screens
                        top: { md: 80 }, // Adjust top position on desktop
                        right: { md: 20 }, // Align to the right on desktop
                    }}
                >
                    {officials.map((official, index) => (
                        <Paper
                            key={index}
                            elevation={3}
                            sx={{
                                padding: 2,
                                borderRadius: 3,
                                background: '#fff',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                width: { xs: '45%', sm: '190px' }, // 45% width for side-by-side layout
                                minWidth: '140px',
                            }}
                        >
                            <img
                                src={official.img}
                                alt={official.name}
                                style={{
                                    width: '80px', // Reduced width for mobile
                                    height: '100px', // Reduced height for mobile
                                    borderRadius: '10%',
                                    objectFit: 'cover',
                                }}
                            />
                            <Typography
                                mt={1}
                                fontWeight={600}
                                fontSize={{ xs: 12, sm: 16 }}
                                className="ff_baloo"
                                textAlign="center"
                            >
                                {official.name}
                            </Typography>
                            <Typography
                                fontSize={{ xs: 10, sm: 14 }}
                                textAlign="center"
                                className="ff_baloo"
                            >
                                {official.title}
                            </Typography>
                        </Paper>
                    ))}
                </Box>


                {/* Buttons Section */}
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    sx={{
                        flexWrap: 'wrap',
                        mt: 3,
                    }}
                >
                    <Button
                        className="ff_baloo"
                        onClick={handleNavigate}
                        variant="contained"
                        startIcon={<ReportIcon />}
                        sx={{
                            padding: { xs: '8px 20px', sm: '10px 30px', md: '10px 40px' },
                            borderRadius: '25px',
                            fontSize: { xs: '14px', sm: '16px', md: '18px' },
                            background: 'linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%)',
                            '&:hover': { background: 'linear-gradient(90deg, #4A00E0 0%, #8E2DE2 100%)' },
                        }}
                    >
                        तक्रार प्रणाली
                    </Button>

                    <Button
                        className="ff_baloo"
                        onClick={handleNavigateStatus}
                        variant="contained"
                        startIcon={<CheckCircleIcon />}
                        sx={{
                            padding: { xs: '8px 20px', sm: '10px 30px', md: '10px 40px' },
                            borderRadius: '25px',
                            fontSize: { xs: '14px', sm: '16px', md: '18px' },
                            background: 'linear-gradient(90deg, #FF7E5F 0%, #FEB47B 100%)',
                            '&:hover': { background: 'linear-gradient(90deg, #FEB47B 0%, #FF7E5F 100%)' },
                        }}
                    >
                        स्थिती तपासा
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
};

export default UserTakrar; 